/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Metadata Service
 * API for managing interface-specific metadata.
 *
 * The version of the OpenAPI document: 2022-01-26
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { HashicorpCloudMetadata20220126GetMetadataResponseFromJSON, HashicorpCloudMetadata20220126UpsertMetadataRequestToJSON, } from '../models';
/**
 *
 */
export class MetadataServiceApi extends runtime.BaseAPI {
    /**
     * GetMetadata gets all metadata key/value pairs for the specified entity. An entity can be an organization, project, user, or resource, and is specified by the combination of `scope` and `identifier`.
     */
    async getMetadataRaw(requestParameters) {
        if (requestParameters.scope === null || requestParameters.scope === undefined) {
            throw new runtime.RequiredError('scope', 'Required parameter requestParameters.scope was null or undefined when calling getMetadata.');
        }
        if (requestParameters.identifier === null || requestParameters.identifier === undefined) {
            throw new runtime.RequiredError('identifier', 'Required parameter requestParameters.identifier was null or undefined when calling getMetadata.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/metadata/2022-01-26/metadata/scope/{scope}/identifier/{identifier}`.replace(`{${"scope"}}`, encodeURIComponent(String(requestParameters.scope))).replace(`{${"identifier"}}`, encodeURIComponent(String(requestParameters.identifier))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudMetadata20220126GetMetadataResponseFromJSON(jsonValue));
    }
    /**
     * GetMetadata gets all metadata key/value pairs for the specified entity. An entity can be an organization, project, user, or resource, and is specified by the combination of `scope` and `identifier`.
     */
    async getMetadata(scope, identifier) {
        const response = await this.getMetadataRaw({ scope: scope, identifier: identifier });
        return await response.value();
    }
    /**
     * UpsertMetadata upserts metadata key/value pairs for the specified entity. An entity can be an organization, project, user, or resource, and is specified by the combination of `scope` and `identifier`. If metadata does not already exist for the entity, it will be created with the provided key/value pairs. If metadata does exist, the provided key/value pairs will be merged into the existing metadata (using a shallow merge). New keys will be added and existing keys will be overwritten. Only the keys that are provided in the request will be impacted.
     */
    async upsertMetadataRaw(requestParameters) {
        if (requestParameters.scope === null || requestParameters.scope === undefined) {
            throw new runtime.RequiredError('scope', 'Required parameter requestParameters.scope was null or undefined when calling upsertMetadata.');
        }
        if (requestParameters.identifier === null || requestParameters.identifier === undefined) {
            throw new runtime.RequiredError('identifier', 'Required parameter requestParameters.identifier was null or undefined when calling upsertMetadata.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling upsertMetadata.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/metadata/2022-01-26/metadata/scope/{scope}/identifier/{identifier}`.replace(`{${"scope"}}`, encodeURIComponent(String(requestParameters.scope))).replace(`{${"identifier"}}`, encodeURIComponent(String(requestParameters.identifier))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudMetadata20220126UpsertMetadataRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * UpsertMetadata upserts metadata key/value pairs for the specified entity. An entity can be an organization, project, user, or resource, and is specified by the combination of `scope` and `identifier`. If metadata does not already exist for the entity, it will be created with the provided key/value pairs. If metadata does exist, the provided key/value pairs will be merged into the existing metadata (using a shallow merge). New keys will be added and existing keys will be overwritten. Only the keys that are provided in the request will be impacted.
     */
    async upsertMetadata(scope, identifier, body) {
        const response = await this.upsertMetadataRaw({ scope: scope, identifier: identifier, body: body });
        return await response.value();
    }
}
